import React, { useState } from 'react';
import { Header } from './components/Header';
import { Sidebar } from './components/Sidebar';
import { Dashboard } from './components/Dashboard';
export function App() {
  const [activeDepartment, setActiveDepartment] = useState('General Manager Office');
  const [activeModule, setActiveModule] = useState('dashboard');
  return <div className="flex flex-col w-full min-h-screen bg-gray-50" data-id="element-0">
      <Header data-id="element-1" />
      <div className="flex flex-1" data-id="element-2">
        <Sidebar activeModule={activeModule} setActiveModule={setActiveModule} data-id="element-3" />
        <Dashboard activeDepartment={activeDepartment} setActiveDepartment={setActiveDepartment} activeModule={activeModule} setActiveModule={setActiveModule} data-id="element-4" />
      </div>
    </div>;
}